function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { presets as CubicBezier, animate, classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Down, Minus } from '../../common/icons';
import { RcSubCollapseProvider, useCreateSubCollapse } from '../../hooks/collapse';
import { Switch } from '../switch/index';
var Effect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export function CollapseItem(props) {
  var id = props.id,
      className = props.className,
      iconType = props.iconType,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? 'right' : _props$iconPosition,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      renderHead = props.renderHead,
      children = props.children,
      content = props.content;

  var _useCreateSubCollapse = useCreateSubCollapse({
    id: id
  }),
      subCollapse = _useCreateSubCollapse.subCollapse,
      isOpen = _useCreateSubCollapse.isOpen,
      setOpened = _useCreateSubCollapse.setOpened;

  var activeCls = usePrefixCls('claps-item-active');
  var clasli = classnames(usePrefixCls('claps-item'), _defineProperty({}, activeCls, isOpen), className);
  var headerCla = usePrefixCls('claps-item-header');
  var titleCla = usePrefixCls('claps-item-title');
  var wrapCla = usePrefixCls('claps-item-wrap');
  var titleIconCla = usePrefixCls('claps-item-title-icon', _defineProperty({}, 'position', iconPosition));
  var titleArrowCla = usePrefixCls('claps-item-title-arrow');
  var titleIonMinusCla = usePrefixCls('claps-item-title-minus');
  var titleIonPlusCla = usePrefixCls('claps-item-title-plus');
  var wrapContentCla = usePrefixCls('claps-item-wrap-content', _defineProperty({}, 'block', iconPosition));
  var onItemClick = useCallback(function (e) {
    e.preventDefault();
    setOpened(!isOpen);
  }, [isOpen]);
  var initRef = useRef(false);
  var contentRef = useRef(null);
  Effect(function () {
    if (!initRef.current) {
      initRef.current = true;
      return;
    }

    var tick = function tick(percent) {
      handleAnimationTick(contentRef.current, tick, percent, isOpen);
    };

    tick.height = 0;

    var _animate = animate('linear', 400, tick),
        _animate2 = _slicedToArray(_animate, 2),
        start = _animate2[0],
        stop = _animate2[1];

    start();
    return function () {
      tick(1);
      stop();
    };
  }, [isOpen]);
  var MinusClassName = usePrefixCls('claps-item-title-minus-active');

  var renderIcon = function renderIcon() {
    var icon;

    switch (iconType) {
      case 'arrow':
        icon = React.createElement(Down, {
          className: titleArrowCla
        });
        break;

      case 'switch':
        icon = React.createElement(Switch, {
          size: "sm",
          checked: isOpen
        });
        break;

      case 'plus':
        icon = React.createElement("span", {
          className: titleIonMinusCla
        }, React.createElement(Minus, {
          className: titleIonPlusCla
        }), React.createElement(Minus, {
          className: "".concat(titleIonPlusCla, " ").concat(MinusClassName)
        }));
        break;
    }

    return React.createElement("span", {
      className: titleIconCla
    }, icon);
  };

  var renderHeader = function renderHeader() {
    if (renderHead) {
      return React.createElement("div", {
        className: headerCla
      }, renderHead(isOpen, setOpened));
    }

    return React.createElement("div", {
      className: titleCla,
      onClick: onItemClick
    }, iconType && renderIcon(), title);
  };

  return React.createElement(RcSubCollapseProvider, {
    subCollapse: subCollapse
  }, React.createElement("div", {
    className: clasli
  }, renderHeader(), React.createElement("div", {
    className: wrapCla,
    ref: contentRef
  }, React.createElement("div", {
    className: wrapContentCla
  }, typeof content === 'function' ? content() : children))));
}

function handleAnimationTick(element, memo, percent, isOpen) {
  if (!element) {
    return;
  }

  if (!memo.height && element.firstElementChild) {
    memo.height = element.firstElementChild.getBoundingClientRect().height;
  }

  if (isOpen) {
    if (percent >= 0.5) {
      element.style.removeProperty('height');
    } else {
      percent = CubicBezier.easeOut(percent * 2);
      element.style.setProperty('height', "".concat(percent * memo.height, "px"));
    }
  } else {
    if (percent >= 1) {
      element.style.removeProperty('height');
    } else if (percent >= 0.5) {
      percent = CubicBezier.easeIn((1 - percent) * 2);
      element.style.setProperty('height', "".concat(percent * memo.height, "px"));
    } else if (element.style.getPropertyValue('height') !== "".concat(memo.height, "px")) {
      element.style.setProperty('height', "".concat(memo.height, "px"));
    }
  }
}